import React, { createContext, useContext, useState, useMemo } from "react";

// Lightweight global store for the "currently viewed property"
// Used by WhatsAppButton to build a property-aware message.
const PropertyContext = createContext({
  current: null,
  setCurrent: () => {},
});

export const PropertyProvider = ({ children }) => {
  const [current, setCurrent] = useState(null);
  const value = useMemo(() => ({ current, setCurrent }), [current]);
  return (
    <PropertyContext.Provider value={value}>{children}</PropertyContext.Provider>
  );
};

export const useCurrentProperty = () => useContext(PropertyContext);
